<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" v-on:click="closeModal()">
        <div class="modal-container" v-on:click.stop="">
          <button class="modal-close" @click="closeModal()">
            <svg data-v-179ebe4f="" version="1.1" width="14" height="14" viewBox="0 0 14 14"><path fill="none" stroke="#000" stroke-width="1.1" d="M1 1l12 12M13 1L1 13"></path></svg>
          </button>
          <div class="modal-header">
            <h3>{{ params.header }}</h3>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="left">■{{(cart.category) ? cart.category.name : '' | stripTags}}</div>
            </div>
            <div class="row">
              <div class="left">{{(cart.figure) ? cart.figure.name : '' | stripTags}}</div>
              <div class="right">{{(cart.figure) ? cart.figure.price : '' | currency}}</div>
            </div>
            <div class="row">
              <div class="left">{{(cart.design) ? cart.design.name : '' | stripTags}}</div>
              <div class="right">{{ (cart.design)? cart.design.price : '' | currency}}</div>
            </div>

            <div class="marginTop" v-if="cart.parts.length">
              <div class="row">
                <div class="left">■カラー</div>
              </div>
              <div class="row" v-for="part in cart.parts">
                <div class="left">{{part.label || part.name | stripTags}}</div>
                <template v-if="'designs_part' in part">
                  {{part.design_part}}
                  <div class="left color_name">{{part.designs_part.color.name | stripTags}}</div>
                  <div class="right color_price" v-if="part.designs_part.color.price">{{part.designs_part.color.price |
                    currency}}
                  </div>
                </template>
              </div>
            </div>

            <div class="marginTop" v-if="cart.letters.length">
              <div class="row">
                <div class="left">■文字</div>
              </div>
              <div class="row" v-for="letter in cart.letters" v-if="letter.decoration">
                <div class="left">{{letter.name}}</div>
                <div class="left" v-if="letter.decoration.color">
                  <span>{{ letter.decoration.color.name }}</span>
                </div>
                <div class="right" v-if="letter.decoration.price">
                  <span>{{letter.decoration.price | currency}}</span>
                  <br>
                  <span v-if="letter.decoration.color.price">(+{{ letter.decoration.color.price | currency }})</span>
                </div>
              </div>
            </div>

            <hr>
            <div class="row marginTop">
              <div class="left">合計</div>
              <div class="right">{{ basePrice() | currency}}</div>
            </div>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button type="button" class="btn w-auto" @click="closeModal()">閉じる</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import modal from '../service/modal';
  import { mapGetters, mapActions, mapState } from 'vuex'

  export default {
    props: ['params'],
    methods: {
      closeModal() {
        modal.close();
        if (this.params.onOk) {
          this.params.onOk();
        }
      }
    },
    computed: {
      ...mapState(['cart']),
      ...mapGetters(['basePrice']),
    }
  }
</script>

<style lang="scss" scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }

  .modal-container {
    position: relative;
    display: inline-block;
    width: auto;
    margin: 0 auto;
    padding: 20px 30px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    border-radius: 1em;
    background: rgba(255,255,255,0.9);
  }

  .modal-header h3 {
    text-align: center;
    background: #151d66;
    color: white;
    padding: 1em;
    border-radius: 1em;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-footer {
    display: block;
    text-align: center;
    button {
      background-color: #151d66;
      font-size: 1rem;
      padding: 2px 14px;
    }
  }
  .modal-close {
    background: #999999;
    height: 3rem;
    width: 3rem;
    position: absolute;
    color: white;
    border: 0;
    border-radius: 50%;
    z-index: 1010;
    top: 10px;
    right: 10px;
  }
  .modal-default-button {
    float: right;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .row{
    color:black;
    clear:both;
    overflow: auto;
    margin-bottom: 4px;
  }
  .row .left{
    float:left;
    width: 120px;
    text-align:left;
  }
  .row .right{
    float:right;
  }
  .marginTop{
    margin-top:1rem;
  }

</style>
